// @flow
import { combineReducers } from 'redux';
import ui from './ui';
import uiToBeCached from './ui-to-be-cached';
import auth from './auth';

const appReducer = combineReducers({
  ui,
  uiToBeCached,
  auth,
});

const rootReducer = (state: any, action: any) => {
  return appReducer(state, action);
};

export default rootReducer;
